import React from "react";
import { components } from "react-select";
import styled from "styled-components";

const OptionLayout = styled.div`
  display: flex;
  gap: 1rem;
`;
const OptionText = styled.div`
  flex: 1;
`;
const OptionCount = styled.div`
  width: 4rem;
`;
const Count = styled.div`
  background-color: #006699;
  color: #fff;
  border-radius: 1rem;
  text-align: center;
  font-size: 1rem;
  padding: 0.4rem 0.5rem;
  margin: -0.3rem 0;
`;

const CountOption: React.FC<
  React.PropsWithChildren<
    React.ComponentProps<typeof components.Option> & {
      data?: {
        label: string;
        count: number;
      };
    }
  >
> = ({ children, ...rest }) => {
  return (
    <components.Option {...rest}>
      <OptionLayout>
        <OptionText>{rest.data?.label}</OptionText>
        <OptionCount>
          <Count>{rest.data?.count}</Count>
        </OptionCount>
      </OptionLayout>
    </components.Option>
  );
};

export default CountOption;
